import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import MyRoutes from "./MyRoutes";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

function App() {
  const navigate = useNavigate();

  axios.interceptors.request.use(
    function (config) {
      config.headers["Authorization"] =
        "Bearer " + JSON.parse(localStorage.getItem("token"));
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response.status === 401) {
        console.log("hey this is inside if ");
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        navigate("/login");
      }
      return Promise.reject(error);
    }
  );

  return (
    <div className="max-w-screen-2xl m-auto">
      <Navbar />
      <MyRoutes />
      <Footer />
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          // Default options for specific types
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
    </div>
  );
}

export default App;
